module.exports = __webpack_public_path__ + "static/img/kexinwangzhan@2x.68a19e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/kexinwangzhan@2x.png
// module id = gBM3
// module chunks = 1 3 4 5 6 7